export default __webpack_public_path__ + "static/media/papers.7df63616.svg";